(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    // Kurzer Impuls, sobald Horizon das Hinzufuegen meldet. Das Ereignis wird synchron im
  // Absende-Pfad ausgeloest, also nach allen Pruefungen und ohne auf den Server zu warten -
  // und es deckt Produktseite, Schnellkauf und Kaufleiste ab, weil alle drei denselben
  // Knopf bedienen. navigator.vibrate fehlt in Safari auf iOS und am Schreibtisch; das
  // optionale Aufrufen laesst den Fall folgenlos.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add') return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    navigator.vibrate?.(10);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eratec-mega-menu"] && !Shopify.designMode) return;
  try {
    // <eratec-mega-tabs> — winziges Custom-Element analog Concepts tabs-element.
  // Erster Tab default aktiv. Tab-Wechsel per Klick + volle Tastatur-A11y
  // (Pfeiltasten, Home/End, Enter/Space) nach WAI-ARIA Tabs-Pattern.
  // Setzt aria-selected + Roving-tabindex auf den Tabs und toggelt das
  // [hidden]-Attribut der zugehoerigen Panels. KEIN Scroll-Listener.
  if (!customElements.get('eratec-mega-tabs')) {
    class EratecMegaTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        if (this.tabs.length === 0) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.select(this.selectedIndex, false);
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index'), 10) || 0;
      }

      panelFor(tab) {
        return this.querySelector('#' + tab.getAttribute('aria-controls'));
      }

      select(index, focusTab) {
        const clamped = Math.min(Math.max(index, 0), this.tabs.length - 1);
        this.setAttribute('selected-index', clamped.toString());

        this.tabs.forEach((tab, i) => {
          const active = i === clamped;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          const panel = this.panelFor(tab);
          if (panel) panel.hidden = !active;
          if (active && focusTab !== false && this.matches(':focus-within')) {
            tab.focus();
          }
        });
      }

      onKeydown(event, index) {
        let next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (index + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (index - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = this.tabs.length - 1;
            break;
          default:
            return;
        }
        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }
    }

    customElements.define('eratec-mega-tabs', EratecMegaTabs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eratec-produktkarte"] && !Shopify.designMode) return;
  try {
    /*
    Schnellkauf und Ausfuehrungswahl auf der Karte. Ohne JavaScript schickt das Formular
    klassisch an /cart/add, der Wahl-Knopf ist ein Link zur Produktseite.
    Mit JavaScript: wie Horizons product-form das Standard-Ereignis cartLinesUpdate, damit
    Warenkorb-Zaehler und Schublade sich selbst aktualisieren und oeffnen.
  */
  class EratecSchnellkauf extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', (event) => this.kaufen(event));

      this.dialog = this.querySelector('[data-wahl]');
      if (!this.dialog) return;

      const ausloeser = this.querySelector('[data-ausloeser]');
      ausloeser?.setAttribute('aria-haspopup', 'dialog');
      ausloeser?.addEventListener('click', (event) => {
        event.preventDefault();
        // Beim Oeffnen duerfen alle Ausfuehrungsbilder laden – auch die verborgenen, die
        // als lazy in einer display:none-Huelle sonst nie anfangen. Vorher laedt keines,
        // damit ein Raster mit vielen Karten nichts vorlaedt.
        for (const bild of this.dialog.querySelectorAll('[data-stapel] img[loading="lazy"]')) {
          bild.loading = 'eager';
        }
        this.sperren();
        this.dialog.showModal();
      });

      /*
         Riegel wieder auf: nicht am close-Ereignis, das in eingebetteten WebViews
         ausbleibt (dann blieb die Seite fuer immer gesperrt). Das offen-Attribut
         aendert sich auf jedem Weg – Knopf, Escape, Klick daneben, Kauf.
         Gleiche Loesung wie die mobile Schublade in assets/eratec-kopf.js.
      */
      new MutationObserver(() => {
        if (!this.dialog.open) this.freigeben();
      }).observe(this.dialog, { attributeFilter: ['open'] });
      this.querySelector('[data-schliessen]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });

      // Bild der gewaehlten Ausfuehrung zeigen. Die Buehne hat eine feste Hoehe, es
      // ruecken also keine Elemente; die übrigen Bilder laden erst beim Einblenden.
      const stapel = this.dialog.querySelector('[data-stapel]');
      if (stapel) {
        this.dialog.addEventListener('change', (event) => {
          if (event.target.name !== 'id') return;
          for (const folie of stapel.children) {
            folie.hidden = folie.dataset.fuer !== event.target.value;
          }
        });
      }
    }

    /*
       Die Seite hinter dem Dialog darf nicht scrollen (Atakan 2026-09-18, Telefon).
       Gescrollt wird in Horizon 4 nicht das Fenster, sondern .page-wrapper
       (height: 100dvh; overflow: auto) – ein Riegel am body hatte deshalb keine
       Wirkung. Gesperrt wird also, was wirklich scrollt, und danach auf seinen Stand
       zurueckgesetzt; touch-action schluckt die Wischgeste. Fallback fuer Layouts, die
       das Fenster scrollen: der Riegel am body.
    */
    sperren() {
      const huelle = document.querySelector('.page-wrapper');
      this.rolle = huelle && huelle.scrollHeight > huelle.clientHeight ? huelle : null;
      if (this.rolle) {
        this.stand = this.rolle.scrollTop;
        this.rolle.style.overflow = 'hidden';
        this.rolle.style.touchAction = 'none';
        return;
      }
      this.stand = window.scrollY;
      const b = document.body;
      b.style.position = 'fixed';
      b.style.insetInline = '0';
      b.style.width = '100%';
      b.style.top = `${this.stand * -1}px`;
      b.style.touchAction = 'none';
    }

    freigeben() {
      if (this.stand == null) return;
      if (this.rolle) {
        this.rolle.style.overflow = '';
        this.rolle.style.touchAction = '';
        this.rolle.scrollTop = this.stand;
      } else {
        const b = document.body;
        b.style.position = '';
        b.style.insetInline = '';
        b.style.width = '';
        b.style.top = '';
        b.style.touchAction = '';
        window.scrollTo({ top: this.stand, behavior: 'instant' });
      }
      this.stand = null;
    }

    async kaufen(event) {
      event.preventDefault();
      const knopf = this.form.querySelector('button[type="submit"]');
      const meldung = this.querySelector('[data-meldung]');
      if (knopf.getAttribute('aria-busy') === 'true') return;
      knopf.setAttribute('aria-busy', 'true');

      let events;
      try {
        events = await import('@shopify/events');
      } catch (fehler) {
        this.form.submit();
        return;
      }
      const { CartLinesUpdateEvent } = events;

      const daten = new FormData(this.form);
      const bereiche = [...document.querySelectorAll('cart-items-component')]
        .map((element) => element.dataset.sectionId)
        .filter(Boolean);
      if (bereiche.length) daten.append('sections', bereiche.join(','));

      const zusage = CartLinesUpdateEvent.createPromise();
      this.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(daten.get('id')), quantity: 1 }],
          promise: zusage.promise,
        })
      );

      const routen = window.Theme?.routes ?? {};
      try {
        const antwort = await fetch(routen.cart_add_url || '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: daten,
        }).then((r) => r.json());
        if (antwort.status) throw new Error(antwort.message);

        const warenkorb = await fetch(`${routen.cart_url || '/cart'}.js`).then((r) => r.json());
        zusage.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(warenkorb),
          detail: {
            items: warenkorb.items,
            source: 'eratec-schnellkauf',
            sourceId: String(daten.get('id')),
            itemCount: 1,
            sections: antwort.sections,
            didError: false,
          },
        });
        this.melden(meldung, this.dataset.hinzugefuegt);
        this.dialog?.close();
      } catch (fehler) {
        zusage.reject(fehler);
        this.melden(meldung, this.dataset.fehler);
      } finally {
        knopf.removeAttribute('aria-busy');
      }
    }

    melden(ziel, text) {
      if (!ziel) return;
      ziel.textContent = '';
      requestAnimationFrame(() => {
        ziel.textContent = text;
      });
    }
  }

  if (!customElements.get('eratec-schnellkauf')) {
    customElements.define('eratec-schnellkauf', EratecSchnellkauf);
  }
  } catch(e) { console.error(e); }
})();

})();
